import { ConvexReactClient } from "convex/react";

const url = import.meta.env.VITE_CONVEX_URL;
if (!url) {
  throw new Error(
    "Missing VITE_CONVEX_URL. Run `bunx convex dev` once to provision a deployment and write the env vars to .env.local.",
  );
}

export const convex = new ConvexReactClient(url, {
  expectAuth: true,
});
